import { render, staticRenderFns } from "./cadastroZona.vue?vue&type=template&id=352b6da9"
import script from "./cadastroZona.vue?vue&type=script&lang=js"
export * from "./cadastroZona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports